/**
 * Nombre de jours facturés d'une session.
 *
 * La rentabilité multiplie le tarif journalier du formateur — et depuis la
 * reprise des coûts de lieu, le prix de la salle — par `sessions.trainer_days`.
 * Ce compteur était saisi à la main et valait 1 sur 1743 sessions sur 1745,
 * y compris sur des formations de deux jours : le coût formateur y était donc
 * divisé par deux.
 *
 * Il se déduit de la donnée contractuelle : le volume horaire de la formation
 * (`formations.duration`, en heures), à raison de 7 heures par jour.
 *
 * Règle validée sur les données Apteed et Onedys en comparant la durée déclarée
 * à l'étalement réel des sessions :
 *
 *    7 h  -> 1 jour   (366 sessions, étalement réel moyen 1,00)
 *   14 h  -> 2 jours  (133 sessions, étalement réel moyen 2,00)
 *    3-4 h -> 1 jour  (une demi-journée occupe quand même une journée)
 *    8, 11, 12 h -> 2 jours (étalement réel observé 2,00 à 2,14)
 *
 * D'où l'arrondi au SUPÉRIEUR et non une division simple : une formation de 8 h
 * mobilise deux journées, pas 1,14.
 */

/** Volume horaire d'une journée de formation. */
export const HOURS_PER_TRAINING_DAY = 7;

/**
 * Jours facturés déduits de la durée de la formation.
 *
 * Renvoie `{ days, formula }`, ou null si la formation n'a pas de durée
 * exploitable — dans ce cas on ne touche à rien : mettre 0 annulerait le coût
 * formateur, ce qui serait plus faux que de laisser la valeur en place.
 */
export const resolveSessionDays = (formation) => {
  const heures = parseFloat(formation?.duration);
  if (!Number.isFinite(heures) || heures <= 0) return null;
  const days = Math.ceil(heures / HOURS_PER_TRAINING_DAY);
  return { days, formula: `${heures} h ÷ ${HOURS_PER_TRAINING_DAY} h/jour` };
};
